export default __webpack_public_path__ + "static/final-photo-e4d6a6305dac283782656ba8c74ead9a.png";